import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import { InputAdornment, ListItemText, Select } from "@mui/material";
import MenuItemWithoutHighlight from "@entrilia/shared/components/MenuItemWithoutHighlight";
import type { InvestorPortalRoleWithNoneValue } from "../../../../api/types/investorContactsTypes";
import PortalRoleChip from "../../../common/PortalRoleChip";

interface Props<TRole extends InvestorPortalRoleWithNoneValue> {
  role: TRole | "";
  fullWidth?: boolean;
  disabled?: boolean;
  onChange: (role: TRole) => void;
  roleOptions: TRole[];
}

const PortalRoleSelect = <TRole extends InvestorPortalRoleWithNoneValue>({
  role,
  fullWidth,
  disabled,
  onChange,
  roleOptions,
}: Props<TRole>) => {
  return (
    <Select
      displayEmpty
      fullWidth={fullWidth}
      disabled={disabled}
      value={role}
      onChange={(event) => onChange(event.target.value as TRole)}
      startAdornment={
        <InputAdornment position="start">
          <SupervisorAccountOutlinedIcon color="action" />
        </InputAdornment>
      }
      sx={(t) => ({
        width: fullWidth ? undefined : "12rem",
        ".MuiInputBase-input": {
          color: role ? t.palette.text.primary : t.palette.text.secondary,
        },
      })}
      renderValue={(selectedRole: TRole | "") => (selectedRole ? <PortalRoleChip role={selectedRole} /> : "Role")}
    >
      {roleOptions.map((roleOption) => (
        <MenuItemWithoutHighlight key={roleOption} value={roleOption}>
          <ListItemText slotProps={{ primary: { component: "span" } }} primary={<PortalRoleChip role={roleOption} />} />
        </MenuItemWithoutHighlight>
      ))}
    </Select>
  );
};

export default PortalRoleSelect;
